import { distinctUntilChanged, debounceTime } from 'rxjs/operators';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Shop } from './../../../@shared/model/shop.model';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
	FormGroup,
	FormBuilder,
	Validators,
	FormControl,
} from '@angular/forms';
import { Component, OnInit, Inject } from '@angular/core';
import { ShopService } from 'src/app/@shared/services/shop.service';
import { Subject } from 'rxjs';
import { PaymentSystemService } from 'src/app/@shared/services/payment-system.service';

@UntilDestroy()
@Component({
	selector: 'app-order-export-excel',
	templateUrl: './order-export-excel.component.html',
	styleUrls: ['./order-export-excel.component.scss'],
})
export class OrderExportExcelComponent implements OnInit {
	form: FormGroup;

	allOrderStatus: any[] = [
		'PENDING',
		'PROCESSING',
		'SHIPPED',
		'DELIVERED',
		'CANCEL',
	];

	shopSearchSubject: Subject<string> = new Subject<string>();
	shopCtrl = new FormControl();
	paymentSearchSubject: Subject<string> = new Subject<string>();
	paymentCtrl = new FormControl();

	allShop: Shop[] = [];
	allPaymentMethod: Shop[] = [];

	constructor(
		@Inject(MAT_DIALOG_DATA) public data,
		private dialogRef: MatDialogRef<OrderExportExcelComponent>,
		private fb: FormBuilder,
		private readonly shopService: ShopService,
		private readonly paymentSystemService: PaymentSystemService
	) {}

	ngOnInit(): void {
		this.shopSearchDebounce();
		this.paymentMethodSearchDebounce();

		this.getShop();
		this.getPaymentMethod();
		this.enableForm();
	}

	save(): void {
		this.dialogRef.close(this.form.value);
	}

	enableForm() {
		this.form = this.fb.group({
			shop: [''],
			paymentMethod: [''],
			email: [
				'',
				[
					Validators.required,
					Validators.pattern(
						/^([a-zA-Z0-9]+)@([a-zA-z0-9]+)\.([a-z]{2,8})(\.[a-z]{2,8})?$/
					),
				],
			],
			startDate: ['', [Validators.required]],
			endDate: ['', [Validators.required]],
			paymentStatus: [[]],
			orderStatus: [[]],
		});
	}

	getShop(e?) {
		this.shopService
			.filter({ ...e, isActive: true })
			.pipe(untilDestroyed(this))
			.subscribe((shop) => {
				this.allShop = shop.data;
			});
	}

	shopSearchDebounce(): void {
		this.shopSearchSubject
			.pipe(debounceTime(500), distinctUntilChanged(), untilDestroyed(this))
			.subscribe((value: string) => {
				this.getShop({ searchTerm: value });
			});
	}

	shopSearch() {
		this.shopSearchSubject.next(this.shopCtrl.value);
	}

	getPaymentMethod(e?) {
		this.paymentSystemService
			.filter({ ...e, isActive: true })
			.pipe(untilDestroyed(this))
			.subscribe((payment) => {
				this.allPaymentMethod = payment.data;
			});
	}

	paymentMethodSearchDebounce(): void {
		this.paymentSearchSubject
			.pipe(debounceTime(500), distinctUntilChanged(), untilDestroyed(this))
			.subscribe((value: string) => {
				this.getPaymentMethod({ searchTerm: value });
			});
	}

	paymentSearch() {
		this.paymentSearchSubject.next(this.paymentCtrl.value);
	}

	today() {
		return new Date();
	}

	// onPaymentMethodRemoved(index: number) {
	// 	const paymentMethod = this.form.get('paymentMethod').value as string[];
	// 	paymentMethod.splice(index, 1);
	// 	this.form.get('paymentMethod').setValue(paymentMethod);
	// }

	// onPaymentStatusRemoved(index: number) {
	// 	const paymentStatus = this.form.get('paymentStatus').value as string[];
	// 	paymentStatus.splice(index, 1);
	// 	this.form.get('paymentStatus').setValue(paymentStatus);
	// }

	// onOrderRemoved(index: number) {
	// 	const orderStatus = this.form.get('orderStatus').value as string[];
	// 	orderStatus.splice(index, 1);
	// 	this.form.get('orderStatus').setValue(orderStatus);
	// }
}
